(() => {
  const mobile = () => matchMedia('(max-width: 749px)').matches;
  const rootUrl = () => window.Shopify?.routes?.root || '/';

  const clamp = (wrap, value) => {
    const min = Number(wrap.dataset.min || 1);
    const max = Number(wrap.dataset.max || 0);
    const step = Number(wrap.dataset.step || 1);
    let next = Math.max(min, Number(value) || min);
    if (max > 0) next = Math.min(max, next);
    next = min + Math.round((next - min) / step) * step;
    return Math.max(min, next);
  };

  const refreshCart = async () => {
    const url = new URL(rootUrl(), location.origin);
    url.searchParams.set('section_id', 'cart-drawer-section');
    const [cartResponse, drawerResponse] = await Promise.all([
      fetch(`${rootUrl()}cart.js`, { headers: { Accept: 'application/json' }, cache: 'no-store' }),
      fetch(url, { headers: { Accept: 'text/html' }, cache: 'no-store' })
    ]);
    const cart = cartResponse.ok ? await cartResponse.json() : null;
    if (drawerResponse.ok) {
      const doc = new DOMParser().parseFromString(await drawerResponse.text(), 'text/html');
      const fresh = doc.querySelector('theme-drawer#cart-drawer [data-hydration-key="cart-drawer-inner"]');
      const current = document.querySelector('theme-drawer#cart-drawer [data-hydration-key="cart-drawer-inner"]');
      if (fresh && current) current.replaceWith(fresh);
    }
    const icon = document.querySelector('cart-icon');
    if (cart && icon && typeof icon.renderCartBubble === 'function') await icon.renderCartBubble(cart.item_count || 0);
  };

  document.addEventListener('click', async event => {
    if (!mobile()) return;

    const logo = event.target.closest('[data-wemond-mobile-home-logo]');
    if (logo) {
      event.preventDefault();
      sessionStorage.setItem('wemond-mobile-home-top', '1');
      location.assign(logo.href || rootUrl());
      return;
    }

    const control = event.target.closest('[data-wms-mobile-minus],[data-wms-mobile-plus],[data-wms-mobile-add]');
    if (!control) return;
    const wrap = control.closest('[data-wms-mobile-buy]');
    if (!wrap) return;
    event.preventDefault();
    event.stopPropagation();

    const output = wrap.querySelector('[data-wms-mobile-quantity]');
    const current = Number(output?.textContent || wrap.dataset.min || 1);
    if (control.matches('[data-wms-mobile-minus],[data-wms-mobile-plus]')) {
      const direction = control.hasAttribute('data-wms-mobile-plus') ? 1 : -1;
      if (output) output.textContent = String(clamp(wrap, current + direction * Number(wrap.dataset.step || 1)));
      return;
    }
    if (control.disabled || control.dataset.busy === 'true') return;
    control.dataset.busy = 'true';
    control.disabled = true;
    const status = wrap.querySelector('[data-wms-mobile-status]');
    try {
      const response = await fetch(`${rootUrl()}cart/add.js`, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify({ items: [{ id: Number(wrap.dataset.variantId), quantity: clamp(wrap, current) }] })
      });
      if (!response.ok) throw new Error('add');
      await refreshCart();
      control.dataset.added = 'true';
      if (status) status.textContent = 'Ürün sepete eklendi.';
      window.WemondMiniCart?.open?.({ announceAdd: true });
      setTimeout(() => {
        delete control.dataset.added;
        control.disabled = false;
        delete control.dataset.busy;
      }, 1100);
    } catch (_) {
      if (status) status.textContent = 'Ürün eklenemedi. Lütfen tekrar dene.';
      control.disabled = false;
      delete control.dataset.busy;
    }
  });

  if (mobile() && sessionStorage.getItem('wemond-mobile-home-top') === '1') {
    sessionStorage.removeItem('wemond-mobile-home-top');
    if ('scrollRestoration' in history) history.scrollRestoration = 'manual';
    scrollTo(0, 0);
    requestAnimationFrame(() => scrollTo(0, 0));
  }
})();
